import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qvptz4nibr: FaireBrandEntity = {
  token: "b_qvptz4nibr",
  type: "brand",
  name: "Trendy Tripper",
  avatarUrl:
    "https://cdn.faire.com/fastly/6ece0ffe9fe82a38fb7b516167df2f7f96c15fcf33fc2b5dcbf195346ec32d54.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/83dcf019d0e39434065c3fb040be466d150164b839326957dacf836164d09bdc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6ece0ffe9fe82a38fb7b516167df2f7f96c15fcf33fc2b5dcbf195346ec32d54.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/83dcf019d0e39434065c3fb040be466d150164b839326957dacf836164d09bdc.jpeg",
  location: "TRAVERSE CITY, MI, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 31,
  isTopShop: true,
  isInsider: true,
  description:
    "I've had a love for textiles, colors and fabric prints since I was a child.  After spending years quilting, sewing clothes for my children and weaving baskets, I made the decision to start my own small business 10 years ago. My focus has been on sustainable, earth-friendly goods that are functional and artistic.  I love colors so you'll see a nice assortment of colorful designs that I'm sure will add some fun to your customer's homes.  \nI commission various female artists who illustrate midcentury modern designs that I have printed in Sweden on sponge cloths made in Germany.  Every product listed is in stock in the US, ready for shipment.  In case you don't know this fact - the Swedish dishcloths were invented in 1949 in Sweden and are a staple in nearly every Swedish home bringing functional art to the kitchen.  After a couple hundred uses, these sponge cloths can be cut up and tossed in your home compost where they degrade - we say \"from the earth, back to the earth!\"  I do not include individual packaging for the Swedish dishcloths in an effort to be truly eco-friendly and nice to our planet.  Thank you for considering my Swedish dishcloths for your shop.  Enjoy!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:24.633Z",
    importedBy: "entity-db-cli",
  },
};
